import { Component } from '@angular/core'
import { AutomationDateRuleTypes, AutomationEventTypes, AutomationTypes } from '@tokeet-frontend/automations'
import { FormBuilder, FormControl, Validators } from '@angular/forms'
import { select, Store } from '@ngrx/store'
import { AutomationWizardPanelBaseComponent } from '@tv3/containers/automations/automations-wizard/automation-wizard-panel.component'
import { guestExpenseNotificationMessages, userExpenseNotificationMessages } from './messages'
import * as moment from 'moment/moment'
import { AuthService } from '@tv3/services/auth.service'
import {
  DataCheckerService,
  ExpenseSettingsGuard,
  isSomething,
  selectExpenseSettings,
  untilDestroy,
  UpdateExpenseSettings,
} from '@tokeet-frontend/tv3-platform'
import { filter } from 'rxjs/operators'
import { Actions } from '@ngrx/effects'

@Component({
  selector: 'app-expense-automation-wizard',
  templateUrl: './expense-automation-wizard.component.html',
  styleUrls: ['./expense-automation-wizard.component.scss'],
})
export class ExpenseAutomationWizardComponent extends AutomationWizardPanelBaseComponent {
  type = AutomationTypes.Expense

  guestNotificationMessages = guestExpenseNotificationMessages
  userNotificationMessages = userExpenseNotificationMessages

  taskForPaidExpense = {
    name: $localize`Create a task and assign to a user`,
    user_ids: [this.auth.user.id],
    start: {
      base: AutomationDateRuleTypes.AfterCheckIn, // TODO
      days: 0,
      hours: 1,
    },
    due: {
      base: AutomationDateRuleTypes.AfterCheckIn, // TODO
      days: 0,
      hours: 2,
    },
    notes: 'Expense is paid',
    timezone: moment.tz.guess(),
  }

  autoApproveAmountCtrl = new FormControl(0, { updateOn: 'blur', validators: [Validators.required] })

  constructor(
    private auth: AuthService,
    private dataChecker: DataCheckerService,
    protected actions: Actions,
    protected fb: FormBuilder,
    protected store: Store<any>
  ) {
    super(actions, store, fb)
    this.form.patchValue({ event: AutomationEventTypes.ExpenseCreated })

    this.dataChecker.check([ExpenseSettingsGuard])
  }

  ngOnInit() {
    super.ngOnInit()

    this.store.pipe(select(selectExpenseSettings), filter(isSomething), untilDestroy(this)).subscribe((settings) => {
      this.autoApproveAmountCtrl.setValue(settings.auto_approve_amount || 0, { emitEvent: false })
    })

    this.autoApproveAmountCtrl.valueChanges.pipe(untilDestroy(this)).subscribe((amount) => {
      this.store.dispatch(UpdateExpenseSettings({ payload: { auto_approve_amount: amount } }))
    })
  }
}
